import React, { Component, lazy, Suspense } from 'react';
import { Tabs, Button, Checkbox, message, Select } from 'antd';
import CarPicturesList from './CarPicturesList/index';
import './style.scss';
import { getPicsClassify, deletePics } from '@service/report';
import { flatten } from '../../../../utils/index';
import api from '../../../../utils/api';
import MaterialsTreeData from '../TravelLicenseForm/MaterialsTreeData'
import RewriteDropdown from '../TravelLicenseForm/rewriteDropdown.js'
import RecycleList from '../../RecycleList';
import { withRouter } from 'react-router-dom';

const Media = lazy(() => import('../s3Media'))

const { Option } = Select, { TabPane } = Tabs;

class CarAndCardPics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mediaCount: 0,
            photos: [],
            downloadBtnText: '下载文件',
            isShowTreeData: false,
            selectedPics: [],
            lossers: [],
            selectedLoss: '',
            activeKey: '',
            recycleVisible: false
        };
    }

    tabClick = (value) => {
        this.setState({
            activeKey: value
        })
        this._getPicsClassify();
    };
    // 获取音视频资源的总数
    getCount = (count) => {
        this.setState({
            mediaCount: count
        });
    };
    setPhotos = (tabKey, picList) => {
        const { photos } = this.state;

        this.setState({
            photos: photos.map(category => category.key === tabKey ? ({
                ...category,
                list: picList
            }) : category)
        });
    };
    _getPicsClassify(data = {}) {
        const { flowId } = this.props;
        const { selectedLoss } = this.state;
        const params = {
            flowId: data.flowId || flowId,
            lossId: selectedLoss
        };
        getPicsClassify(params).then(({ result: { list, lossers } }) => {
            this.setState({
                photos: list.map(category => ({
                    ...category,
                    list: flatten(category.secondTypes.map(item => item.pics)).map(item => ({ ...item, originalRotate: item.rotate })).sort((a, b) => a.sortIndex - b.sortIndex)
                })),
                lossers
            });
        });
    }
    componentDidMount() {
        const { flowId } = this.props;
        getPicsClassify({
            flowId: flowId
        }).then(({ result: { list, lossers } }) => {
            this.setState({
                photos: list.map(category => ({
                    ...category,
                    list: flatten(category.secondTypes.map(item => item.pics)).map(item => ({ ...item, originalRotate: item.rotate })).sort((a, b) => a.sortIndex - b.sortIndex)
                })),
                lossers,
                activeKey: list.length ? list[0].key : 'mediaList',
                selectedLoss: lossers.length ? lossers[0].lossId : ''
            });
        });
        window.addEventListener('message', this.receiveMessage, false);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false);
    }

    receiveMessage = async (event) => {
        const data = event.data;
        if (data.eventName === 'refreshPicsClassify') {
            // 更新图片列表
            await this._getPicsClassify({ flowId: data.flowId });
        }
    };

    /*
     * 下载文件
     * */
    handleDownLoad = () => {
        let _this = this;
        this.setState({ downloadBtnText: '正在打包' });
        let { currentPreviewReport } = this.props.reportPreview;
        api('/zipFileToFtp')
            .post({ reportId: currentPreviewReport._id })
            .then(response => {
                _this.setState({ downloadBtnText: '下载文件' })
                //https://192.168.1.65:60803/zip/new.zip
                let { errCode, result, errInfo } = response;
                if (errCode === 0) {
                    if (result && result.length > 0) {
                        _this.downloadFile(result)
                    } else {
                        message.warning('没有图片可供下载！')
                    }
                } else {
                    message.error(errInfo)
                }
            });
    }
    downloadFile(url) {
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        } catch (e) {

        }
    }

    showTreeData = () => {
        const elements = document.getElementsByClassName('car-pictures-list')
        for (let index = 0; index < elements.length; index++) {
            const element = elements[index];
            element.style.width = '59%'
        }
        this.setState({
            isShowTreeData: true
        })
    }

    hideTreeData = () => {
        const elements = document.getElementsByClassName('car-pictures-list')
        for (let index = 0; index < elements.length; index++) {
            const element = elements[index];
            element.style.width = '100%'
        }

        this.setState({
            isShowTreeData: false
        })
    }


    openWindow = () => {
        const { flowId } = this.props;
        const url = `/photo/${window.btoa(flowId)}?token=${window.btoa(window.accessToken)}&canOcr=1`
        window.open(`/iframe/${encodeURIComponent(url)}`)
    }

    handleDelete = () => {
        const { selectedPics } = this.state;
        if (!selectedPics.length) {
            this.setState({
                recycleVisible: true
            })
            return
        }
        deletePics({
            flowId: this.props.flowId,
            picIds: selectedPics
        }).then(() => {
            message.success('删除成功');
            this.setState({
                selectedPics: []
            })
            // 归类结束后更新图片列表
            window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
        })
    }

    // 归类
    classifyPics = async (toLossId, label, ForensicsPhotoType = '', subLabel = '') => {
        const { selectedPics = [] } = this.state
        const { actions } = this.props;
        let data = {
            flowId: this.props.flowId,
            label: label || '',
            subLabel: subLabel || '',
            picIds: selectedPics,
            lossId: toLossId,
        }
        if (!selectedPics.length) {
            message.warning('请选择照片')
            return
        }

        let result = await actions.cpic_classify_pics(data)

        if (!result.error) {
            this.setState({
                selectedPics: []
            })
            message.success('分类成功');

            // 归类结束后更新图片列表
            window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')

        } else {
            message.error('分类失败')
        }
    }

    handelSelectPicture = (e, id) => {//选中图片
        this.setState(({ selectedPics }) => ({
            selectedPics: selectedPics.includes(id) ? selectedPics : [...selectedPics, id]
        }));
    }

    handelCancelPicture = (e, id) => {//取消图片选中
        const { selectedPics } = this.state;
        this.setState({
            selectedPics: selectedPics.filter(item => item !== id)
        })
    }

    getCurrentCategoryPictureIds = () => {
        const { photos, activeKey } = this.state;
        const currentCategory = photos.find(item => item.key === activeKey);
        return (currentCategory && currentCategory.list || [])
            .map(item => item && item._id)
            .filter(Boolean);
    }

    toggleCurrentCategoryPictures = (event) => {
        const currentPictureIds = this.getCurrentCategoryPictureIds();
        if (!currentPictureIds.length) return;
        const currentPictureIdSet = new Set(currentPictureIds);

        this.setState(({ selectedPics }) => ({
            // 全选只补充当前分类，取消全选也只移除当前分类，其他分类的选择保持不变。
            selectedPics: event.target.checked
                ? Array.from(new Set([...selectedPics, ...currentPictureIds]))
                : selectedPics.filter(id => !currentPictureIdSet.has(id))
        }));
    }

    changeCurrentCar = (value) => {
        this.setState({
            selectedLoss: value
        }, () => {
            window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
        })
        // 切换标的三者时更新图片列表

    }
    onSuccess = () => {
        window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
    }
    render() {
        const {
            reportPreview
        } = this.props,
            { mediaCount, photos, downloadBtnText, selectedPics, selectedLoss, lossers, activeKey, recycleVisible } = this.state;
        const { currentPreviewReport } = reportPreview;
        const currentPictureIds = this.getCurrentCategoryPictureIds();
        const currentSelectedCount = currentPictureIds
            .filter(id => selectedPics.includes(id)).length;
        const isCurrentCategorySelected = currentPictureIds.length > 0
            && currentSelectedCount === currentPictureIds.length;

        let classifyButton
        if (selectedPics && selectedPics.length > 0) {
            // 分类下拉选项
            classifyButton =
                <span className="classify_pics_span">
                    <RewriteDropdown
                        report={currentPreviewReport}
                        classifyPics={this.classifyPics}
                    >
                    </RewriteDropdown>
                </span>
        } else {
            classifyButton = <span className="classify_pics_span"><Button disabled>移动</Button></span>
        }
        return (
            // 我的任务
            <div className="car-and-card-pics" style={{ height: '100%' }}>

                <div className="classify_pics_div">
                    <Button style={{ marginRight: 5 }} onClick={this.handleDownLoad}>{downloadBtnText}</Button>
                    <Button style={{ marginRight: 5 }} onClick={this.showTreeData}>材料明细</Button>
                    <Button style={{ marginRight: 5 }} onClick={this.openWindow}>超级视图</Button>

                    <Checkbox
                        checked={isCurrentCategorySelected}
                        indeterminate={currentSelectedCount > 0 && !isCurrentCategorySelected}
                        disabled={!currentPictureIds.length || this.props.disabled}
                        onChange={this.toggleCurrentCategoryPictures}
                        style={{ marginRight: 8 }}
                    >
                        全选当前分类
                    </Checkbox>

                    {classifyButton}
                    <Button style={{ transition: 'all  0.1s', padding: '0 10px' }} onClick={this.handleDelete}>
                        <i className="iconfont icon-del-full"></i>
                    </Button>
                </div>
                <Tabs
                    destroyInactiveTabPane
                    onTabClick={this.tabClick.bind(this)}
                    activeKey={activeKey}
                    mode={'left'}
                    tabBarExtraContent={{
                        left: lossers && lossers.length ? <Select defaultValue={selectedLoss} value={selectedLoss} onChange={this.changeCurrentCar} style={{ width: 100, marginRight: 20 }}>
                            {
                                lossers.map(item => <Option key={item.lossId} value={item.lossId}>{item.name}</Option>)
                            }
                        </Select> : null
                    }}
                >
                    {
                        photos.map(photo => <TabPane tab={`${photo.name.replace('材料', '')}(${photo.picLen})`} key={photo.key}>
                            <CarPicturesList
                                carPictures={photo.list}
                                selectedState={selectedPics}
                                handelSelectPicture={this.handelSelectPicture}
                                handelCancelPicture={this.handelCancelPicture}
                                tabKey={photo.key}
                                setPhotos={this.setPhotos}
                                lossers={lossers}
                                curLoss={selectedLoss}
                                {...this.props}
                            />
                        </TabPane>)
                    }

                    {
                        <TabPane forceRender tab={`音视频(${mediaCount})`} key="mediaList">
                            <Suspense fallback={<div style={{ textAlign: 'center', margin: 20 }}>加载中...</div>}>
                                <Media
                                    flowId={this.props.flowId}
                                    getCount={this.getCount}
                                    uploadVisible={this.props.uploadPermission}
                                />
                            </Suspense>
                        </TabPane>
                    }
                </Tabs>
                {
                    this.state.isShowTreeData ? <div className='materials-tree-data-container'>
                        <MaterialsTreeData
                            hideTreeData={this.hideTreeData}
                            flowId={this.props.flowId}
                            agentId={this.props.currentAgent._id}
                        />
                    </div> : null
                }
                {
                    recycleVisible ? <RecycleList visible={recycleVisible} flowId={this.props.flowId} onCancel={() => this.setState({ recycleVisible: false })} onSuccess={this.onSuccess} /> : null
                }
            </div>
        );
    }
}

export default withRouter(CarAndCardPics);
